import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { StravaDetailPage } from "src/pages/StravaDetailPage";
import { stravaStatusQueryOptions } from "src/queries/integrations";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/integrations/strava/",
)({
  component: StravaDetailPage,
  loader: async ({ context }) => {
    return loaderHandler(async () => {
      await context.queryClient.query({
        ...stravaStatusQueryOptions(),
        staleTime: "static",
      });
      return { data: null };
    });
  },
});
